import * as React from "react";
import { useEffect } from "react";

import Wheel from "./Wheel/Wheel";
import Carousel from "./Carousel";
import JackpotInfoBox from "./Jackpot/JackpotInfoBox";
import InfoBoxesHolder from "../Common/InfoBox/InfoBoxesHolder";

import { GameTypeEnum, JackpotTypeEnum } from "../../enums";
import SwitchTabArrow from "./SwitchTabArrow";
import { usePageVisible } from "../../hooks/usePageVisible";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setIsBrowserTabOrWindowInterrupt } from "../../store/picks/tabs-slice";

const DrawingPanel: React.FC = () => {
  const page = usePageVisible();
  const dispatch = useAppDispatch();
  const gameType = useAppSelector((state) => state.config.gameType);
  const isDesktopScreen = useAppSelector(
    (state) => state.config.isDesktopScreen
  );

  useEffect(() => {
    if (page.hasLostFocus) {
      dispatch(setIsBrowserTabOrWindowInterrupt(true));
    }
  }, [page, dispatch]);

  return (
    <main className={`${isDesktopScreen ? "shellPanel_draw" : ""}`}>
      <div className="info_box_container info_box_jackpot">
        <JackpotInfoBox type={JackpotTypeEnum.GOLD} />
        <JackpotInfoBox type={JackpotTypeEnum.SILVER} />
      </div>
      <Wheel />
      <Carousel />
      {gameType === GameTypeEnum.ONLINE && (
        <InfoBoxesHolder showHistory={false} />
      )}

      {gameType === GameTypeEnum.ONLINE && <SwitchTabArrow />}
    </main>
  );
};

export default DrawingPanel;
